import { useMemo } from 'react';

// export type CatalogueDesignKey = 'moderno' | 'minimalista' | 'clean' | 'soft-commerce';
export type CatalogueDesignKey = 'minimalista' | 'soft-commerce';

export interface CatalogueDesign {
  key: CatalogueDesignKey;
  label: string;
  /** Texto descriptivo opcional para futuros usos en tooltips u opciones */
  description?: string;
}

export const DEFAULT_CATALOGUE_DESIGN: CatalogueDesignKey = 'soft-commerce';

export const CATALOGUE_DESIGNS: Record<CatalogueDesignKey, CatalogueDesign> = {
  // moderno: { key: 'moderno', label: 'Moderno' },
  minimalista: { key: 'minimalista', label: 'Minimalista' },
  // clean: { key: 'clean', label: 'Clean' },
  'soft-commerce': { key: 'soft-commerce', label: 'Soft Commerce' },
};

export const getCatalogueDesignClass = (design: CatalogueDesignKey) => `catalogue-design--${design}`;

export const isValidCatalogueDesign = (design?: string | null): design is CatalogueDesignKey => {
  if (!design) return false;
  return (design as CatalogueDesignKey) in CATALOGUE_DESIGNS;
};

export const useCatalogueDesignOptions = () =>
  useMemo(() => Object.values(CATALOGUE_DESIGNS), []);
